import {} from "react";
import makeStyles from "styles/muiStylesCompat/makeStyles";
import Paper from "@mui/material/Paper";

const useStyles = makeStyles((_theme) => ({
  paper: {
    padding: "48px",
    borderRadius: 32,
  },
}));

const PaperView = (props) => {
  const { children } = props;
  const classes = useStyles();

  return (
    <Paper className={classes.paper} square={false}>
      {children}
    </Paper>
  );
};

export default PaperView;
